/** @format */

export function getQrUrl() {
	return "https://app.made.live/id/w/" + this.id;
}
